var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookmarkRegular(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 23,
    viewBox: "0 0 17 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.875 0H2.125C0.95138 0 0 0.965371 0 2.15625V21.558C0 22.6676 1.18602 23.3585 2.13031 22.7996L8.5 19.0289L14.8706 22.7992C15.8135 23.3189 17 22.6676 17 21.558V2.15625C17 0.965371 16.0482 0 14.875 0ZM14.875 20.3047L8.5 16.5312L2.125 20.3047V2.42578C2.125 2.27439 2.24143 2.15625 2.35078 2.15625H14.5695C14.7599 2.15625 14.875 2.27439 14.875 2.42578V20.3047Z",
    fill: "#1C3451",
    fillOpacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmarkRegular);
export default __webpack_public_path__ + "static/media/bookmarkRegular.115cb1702e9646f30c850071ffd59a4a.svg";
export { ForwardRef as ReactComponent };